import styled from 'styled-components'
import media from '../../../../services/generateMediaQueries'

export const FormWrapper = styled.div`
  margin: 1.5rem 0;
  width: 400px;
  ${media.lessThan('medium')`
    width: 100%;
  `}
`
export const Title = styled.h1`
  max-width: 350px;
  font-size: 1.5rem;
  text-align: center;
  margin: auto;
  margin-top: 0;
  color: #3b3636;
  font-weight: var(--font-weight-boldest);
`
export const ReferralContainer = styled.div`
  width: 100%;
  padding: 24px;
  margin: 32px 0;
  border-radius: 16px;
  background-color: #f1f1f1;
`
export const ReferralTitle = styled.p`
  color: #3b3636;
  font-weight: var(--font-weight-boldest);
  margin-top: 0;
  margin-bottom: 4px;
`
export const ReferralDescription = styled.div`
  font-size: 13px;
  padding-bottom: 8px;
`
